import React from "react";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import SectionSelector from "./sectionSelector";
import Modules from "./modules";
import Menus from "./menus";
import Exclusions from "./exclusions";

const ModulesAndMenus = () => {

  return (
    <CommonPage
      isNotGridPage
    >
      <SectionSelector
        sections={[
          {
            key: 0,
            label: getLocalizedString("modules"),
            content: <Modules />,
          },
          {
            key: 1,
            label: getLocalizedString("menus"),
            content: <Menus />,
          },
          {
            key: 2,
            label: getLocalizedString("exclusions"),
            content: <Exclusions />,
          },
        ]}
      />
    </CommonPage>
  )
}

export default ModulesAndMenus;